import { useEffect } from 'react';

const robotsContent = `User-agent: *
Disallow:
Sitemap: https://www.bioetiket.com/sitemap.xml`;

export default function RobotsTxt() {
  useEffect(() => {
    document.title = 'robots.txt';
    // Set plain text content type via meta (best effort in SPA)
  }, []);

  return (
    <pre
      style={{
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        padding: '16px',
        margin: 0,
        background: '#fff',
        color: '#000',
        fontSize: '14px',
        lineHeight: '1.6',
      }}
    >
      {robotsContent}
    </pre>
  );
}
